import React from 'react';
import styled from 'styled-components';
import { Field } from 'react-final-form';
import { FlexMiddle } from '../Flex';
import RadioButton from '../RadioButton';

const Wrapper = styled(FlexMiddle)`
  padding: 9px 0;
`;

const RadioField = ({ name, validate, onChange, options = [], className }) => (
  <Wrapper className={className}>
    {options.map((option) => (
      <Field
        key={option?.value !== undefined ? option?.value : option}
        name={name}
        validate={validate}
        render={({ input }) => (
          <RadioButton
            content={option?.label || option}
            id={option?.value !== undefined ? option?.value : option}
            {...input}
            onChange={onChange || input.onChange}
            disabled={option.disabled}
          />
        )}
      />
    ))}
  </Wrapper>
);

export default RadioField;
